import React from 'react';
import styles from './ActionTile.module.scss';
import { NavigateToInternalUrl } from '../../../../../utils/api.utils';
import { Routes } from '../../../../../types/constants';

interface ActionTileProps {
    title: string;
    description: string;
    label: string;
    route?: Routes;
    onAction?: () => void;
}

const ActionTile = ({ title, description, label, route, onAction }: ActionTileProps) => {
    const handleAction = () => {
        if (onAction) {
            onAction();
            return;
        }
        if (route) {
            NavigateToInternalUrl(route);
        }
    };

    return (
        <div className={styles.tile}>
            <h3 className={styles.title}>{title}</h3>
            <p className={styles.description}>{description}</p>
            <button type="button" className={styles.button} onClick={handleAction}>
                {label}
            </button>
        </div>
    );
};

export default ActionTile;
